import httpGet from "./httpget";
import httpPost from "./httppost";
const domain = "https://webpdfapi.foxitcloud.cn";
// fid获取用户token
export const getToken = (params = {}, config = {}) =>
httpPost({
    url: `${domain}/getToken?fid=${window.readerCookies.fid}`,
    params,
    config
  });
// 获取用户信息
export const getUserInfo = (config = {}) => {
  return httpGet({
    url: config.params.token
      ? `${domain}/getUserInfo?plateform=wechatmp`
      : `${domain}/getUserInfo?`,
    config
  });
}
// 刷新用户信息
export const userRefresh = (config = {}) => {
  return httpGet({
    url: (config && config.params && config.params.token)
      ? `${domain}/refresh?plateform=wechatmp`
      : `${domain}/refresh`,
    params: config.params,
    config
  });
};
// 发送参数提供给云办公发起会议
export const cmisInfo = (params = {}, config = {}) => {
  return httpPost({
    url: `${domain}/cmisInfo`,
    params,
    config
  });
};
export const shareWXACode = (params = {}, config = {}) => {
  return httpPost({
    url: `https://wechatmp.foxitreader.cn/wxacode/getUnlimited?appId=wxeeeee850023ae299&page=pages/Share/Share&scene=${encodeURIComponent(params.shareId)}`,
    config
  })
}
// 上传转换文件
export const convertUpload = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/files/upload`,
    params:config.params,
    config
  });
};
// 文件转换
export const convertTask = (config = {}) => {
  return httpPost({
    url: `${domain}/v1/api/files/conversionTask`,
    params:config.params,
    config
  });
};
// 文件转换查询结果
export const convertChangeResult = (config = {}) => {
  return httpGet({
    url: `${domain}/v1/api/files/progressRate`,
    params:config.params,
    config
  });
};

// 广告接口
export const getAdList = (config = {}) => {
  return httpGet({
    url: `${domain}/advertise/getAdList?type=1`,
    params:config.params,
    config
  });
};


